import { LoadableApp } from 'ui-seeker/core'
import { TP_DESTINATION, TP_COMPETENCE } from 'app/config'

const Destination = LoadableApp(import('./Destination'))
const Competence = LoadableApp(import('./Competence'))

const PageRoutes = [
    { path: TP_DESTINATION.path, component: Destination, needLogin: true, header: false },
    { path: TP_COMPETENCE.path, component: Competence, needLogin: true, header: false },
]

export default PageRoutes